<template lang='pug'>
  div(class="c-load")
    p(class="u-mb3 u-mt0 u-white u-fz-h1") {{message}}
    pulse-loader(color="white" size="20px")
</template>

<script>
  export default {
    props: {
      message: {
        type: String,
        default: 'Cargando'
      }
    },

    mounted () {
      window.$('body').css('overflow-y', 'hidden')
    },

    beforeDestroy () {
      window.$('body').css('overflow-y', '')
    }
  }
</script>



// WEBPACK FOOTER //
// src/app/shared/components/Loading.vue